import React from 'react';
import styled from '@emotion/styled/macro';
import { MatrixTableCellProps } from './matrix-table.types';

const MatrixTableCell: React.FC<MatrixTableCellProps> = ({
  content,
  isRowlLabel = false,
}) => {
  let validateContent = content;
  if (content === '' || content === undefined) {
    validateContent = '-';
  }
  return (
    <td
      className={isRowlLabel ? 'row-label' : ''}
      data-testid="matrix-table-cell"
    >
      {validateContent}
    </td>
  );
};

const StyledMatrixTableCell = styled(MatrixTableCell)``;

export default StyledMatrixTableCell;
